import React, {Component} from "react" ;
import "../../util/explorer_support";
import {getLabelByValue} from "../../util/Helpers";

class Body extends Component {
	render() {
		return (
			<tbody>
			{
					this.props.types.map((item, i) =>
						<tr key={i} style={this.props.getTrStyles !== undefined ? this.props.getTrStyles(item,i) : {}} className={this.props.getTrClass !== undefined ? this.props.getTrClass(item) : {}}>
							{
								this.props.columns.map((column, j) =>
								typeof column.accessor === "string" ? (column.Cell === undefined ?
										<td key={j} style={column.getTdStyles && column.getTdStyles(item)} data-label={column.Header}>{getLabelByValue(this.props.items,item.value, true) +' ₺'}</td> :
										<td key={j} style={column.getTdStyles && column.getTdStyles(item)} data-label="">{column.Cell(item, i)}</td>
								) : (<td key={j} style={column.getTdStyles && column.getTdStyles(item)} data-label="">
										{
											(column.Cell === undefined ?
													column.accessor.map((data, k) =>
														<p key={k}>{item[data.accessor] + (k + 1 < column.accessor.length ? "-" : "")}</p>
													) :
													column.Cell("column: ",this.props.items[i], i)
											)
										}

									</td>
								))
							}
						</tr>
					)
			}
			<tr>
				<td>
					<b>GENEL TOPLAM</b>
				</td>
				<td>
					{this.props.statSums ? this.props.statSums.replace(".",","):"0 ₺"}
				</td>
			</tr>
			</tbody>
		);
	}
}

export default Body;



// WEBPACK FOOTER //
// ./src/components/Table/Body2.js